import React, { Component } from 'react';
import { DatePicker, Input, Button, message } from 'antd';
import fp from '../../../utils/fp';
import moment from 'moment';

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;

class Filter extends Component {
    search = () => {
        this.props.search();
    }

    disabledDate = (current) => {
        const { startMonth, endMonth,  } = this.props;
        return current && (current.valueOf() < moment(startMonth).valueOf() || current.valueOf() > moment(endMonth).valueOf());
    }

    handleDateChange = (data, dateString, key) => {
        const { onChange, searchParams: { startDate, endDate } } = this.props;
        if (key === 'startDate') {
            if (endDate) {
                if (moment(dateString).valueOf() > moment(endDate).valueOf()) {
                    onChange({
                        startDate: endDate,
                        endDate: dateString,
                    });
                    return;
                } else if (moment(dateString).valueOf() === moment(endDate).valueOf()) {
                    message.warning('不能选择单月！');
                    return;
                }
            }
            onChange({ [key]: dateString });
        } else if (key === 'endDate') {
            if (startDate) {
                if (moment(dateString).valueOf() < moment(startDate).valueOf()) {
                    onChange({
                        startDate: dateString,
                        endDate: startDate,
                    });
                    return;
                } else if (moment(dateString).valueOf() === moment(startDate).valueOf()) {
                    message.warning('不能选择单月！');
                    return;
                }
            }
            onChange({ [key]: dateString });
        } else {
            onChange({ [key]: dateString });
        }
    }

    render() {
        const { operable, statisticsDsList, showStatisticsDs, searchParams: { startDate, endDate, selected } } = this.props;
        return (
            <div className="search-bar" style={{ marginBottom: 16 }}>
                <div className="search-item month-range-picker">
                    <label className="ui-label">查询月份</label>
                    <MonthPicker
                        className="begin"
                        format={monthFormat}
                        value={startDate ? moment(startDate) : null}
                        allowClear={false}
                        placeholder="开始月份"
                        disabledDate={this.disabledDate}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startDate')}
                    />
                    <MonthPicker
                        className="end"
                        format={monthFormat}
                        value={endDate ? moment(endDate) : null}
                        allowClear={false}
                        placeholder="结束月份"
                        disabledDate={this.disabledDate}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endDate')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">统计维度</label>
                    <Input
                        placeholder="请选择"
                        value={
                            fp.compose(
                                fp.join(';'),
                                fp.map(fp.prop('name')),
                                fp.filter(i => selected.find(s => s.value === i.value))
                            )(statisticsDsList)
                        }
                        onClick={showStatisticsDs}
                    />
                </div>
                <div className="search-item">
                    <Button type="primary" disabled={!operable} onClick={this.search}>搜索</Button>
                    <Button type="primary" disabled={!operable} onClick={this.props.export}>导出</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/financeManagement/orderChangeReport/Filter.js